module.exports = __webpack_public_path__ + "img/lefticon.929007a6.png";